export enum ProductManualRecommendationTypeCode {
  ACCESSORIES = 'ACCESSORIES',
  BASE_PRODUCT = 'BASE_PRODUCT',
  SIMILAR = 'SIMILAR',
  MANDATORY = 'MANDATORY',
}
